import { createContext } from "react";
import { MachinelogState } from "../states/MachinelogState";

export const MachinelogContext = createContext<MachinelogState>(undefined);

export const MachinelogContextProvider = MachinelogContext.Provider;
